$('.checkout-button.wc-forward').on('click', function () {
    if ($('input[name="cart-t-and-c"]').prop('checked') == false) {
        alert('Please accept the terms and conditions.');
        return false;
    }
});